"use client"

import React, { createContext, useContext, ReactNode } from 'react';

interface QLHVContextType {
    isQLHVMode: boolean;
}

const QLHVContext = createContext<QLHVContextType | undefined>(undefined);

export const useQLHV = () => {
    const context = useContext(QLHVContext);
    if (context === undefined) {
        return { isQLHVMode: false }; // Default value if context is not provided
    }
    return context;
};

interface QLHVProviderProps {
    children: ReactNode;
    isQLHVMode: boolean;
}

export const QLHVProvider: React.FC<QLHVProviderProps> = ({ children, isQLHVMode }) => {
    return (
        <QLHVContext.Provider value={{ isQLHVMode }}>
            {children}
        </QLHVContext.Provider>
    );
};
